import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IconComponent } from '@shared-lib/components/icon/icon.component';

@Component({
  selector: 'cp-ticket-container',
  imports: [CommonModule, IconComponent],
  templateUrl: './ticket-container.component.html',
  styleUrl: './ticket-container.component.scss',
})
export class TicketContainerComponent {
  @Input() labelIcon: string;
  @Input() label: string;
  @Input() image: string;
  @Input() valueLabel: string;
  @Input() value: number;
}
